export default __webpack_public_path__ + "static/media/07.8a379ba0.jpg";